"use client";

import { SidebarInset, SidebarProvider } from "@shared/components/ui/sidebar";
import type { CSSProperties, ReactNode } from "react";
import { AdminSidebar } from "@/components/sidebar.admin";
import { SiteHeader } from "@/components/site-header";
import { AuthGate } from "@/lib/auth";

export const AdminShell = ({ children }: { children: ReactNode }) => {
  return (
    <AuthGate>
      <SidebarProvider
        className="flex min-h-svh w-full flex-col"
        style={
          {
            "--sidebar-width": "calc(var(--spacing) * 72)",
            "--header-height": "calc(var(--spacing) * 12)",
          } as CSSProperties
        }
      >
        <div className="flex min-h-0 min-w-0 flex-1 flex-row">
          <AdminSidebar variant="sidebar" />
          <SidebarInset>
            <SiteHeader />
            <div className="flex flex-1 flex-col">{children}</div>
          </SidebarInset>
        </div>
      </SidebarProvider>
    </AuthGate>
  );
};
